import { ReactNode, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUserSession } from '.';

export interface ProtectedProps {
  children: ReactNode;
  fallback?: ReactNode;
  redirect?: string;
}

function Protected({
  children,
  redirect = '/login',
  fallback = null,
}: ProtectedProps): any {
  const userCtx = useUserSession();
  const navigate = useNavigate();

  useEffect(() => {
    if (userCtx.user || userCtx.isAuthenticating) return;
    userCtx.setToken(null);
    navigate(redirect);
  }, [userCtx, redirect, navigate]);

  if (userCtx.isAuthenticating) return fallback;
  if (userCtx.user) return children;
  return 'Bad auth';
}

export default Protected;
